import React, { FC, useEffect } from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";

import Login from "@/pages/login";
import Forgot from "@/pages/forgot";
import Register from "@/pages/register";

import UserInfo from "@/pages/userInfo";
import Index from "@/pages/index";
import SubjectNavigation from "@/pages/subjectNavigation";
import AllTrain from "@/pages/allTrain";

import Subject from "@/pages/subject";
import PersonCenter from "@/pages/personCenter/index";
import Play from "@/pages/play";
import Main from "@/pages/main";
import Home from "@/pages/home";
import News from "@/pages/newsDetail";
import NewsInfo from "@/pages/newsInfo";
import UpdateUserInfo from "@/pages/updateUserInfo";
import ExpertDemeanorList from "@/pages/expertDemeanorList";
import DemeanorInfo from "@/pages/expertDemeanorList/demeanorInfo/index";
import Footer from "@/components/footer/index";
export function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
export const routes: any[] = [
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/forgot",
    component: Forgot,
  },
  {
    path: "/register",
    component: Register,
  },
  {
    path: "/userInfo",
    component: UserInfo,
  },
  {
    path: "/UpdateUserInfo",
    component: UpdateUserInfo,
  },
  {
    path: "/index",
    component: Index,
    routes: [
      {
        path: "/index/home",
        component: Home,
      },
      {
        path: "/index/main",
        component: Main,
      },
      {
        path: "/index/subjectNavigation",
        component: SubjectNavigation,
      },
      {
        path: "/index/allTrain",
        component: AllTrain,
      },
      {
        path: "/index/subject/:id",
        component: Subject,
      },
      {
        path: "/index/personCenter",
        component: PersonCenter,
      },
      {
        path: "/index/news",
        component: News,
      },
      {
        path: "/index/expertDemeanorList",
        component: ExpertDemeanorList,
      },
      {
        path: "/index/newsInfo",
        component: NewsInfo,
      },
      {
        path: "/index/demeanorInfo",
        component: DemeanorInfo,
      },
    ],
  },
  {
    path: "/play/:courseId/:sectionId",
    component: Play,
  },
];

const RouteConfig: FC<any> = () => {
  return (
    <HashRouter>
      <Switch>
        {routes.map((route, i) => (
          <Route
            key={i}
            path={route.path}
            render={(props) => {
              if (!IsPC()) {
                window.location.href = `${window.location.origin}/continuingEducationMobile/#/`;
              } else {
                return (
                  <>
                    <route.component {...props} routes={route.routes} />
                  </>
                );
              }
            }}
          />
        ))}
        {/* 设置默认路由 */}
        <Redirect path="/" exact={true} to="/index/home" />
      </Switch>
    </HashRouter>
  );
};

export default RouteConfig;
